import { graphql } from 'gql.tada';

export const SidebarFragment = graphql(`
  fragment SidebarFragment on School {
    id
    name
    slug
    parentAlertsSetting {
      enabled
    }
    schoolYears {
      id
      name
      slug
      startDate
      endDate
      state
      viewerTeaches
    }
  }
`);
